import Alert from "./Alert";

const responseHandler = (response) => {
    const { data, problem , ok } = response;
    let res;
    if(ok){
        res = data;
    }else{
        if(problem === "NETWORK_ERROR"){
            res =  "Network Error! Kindly try again.";
            Alert( true , "danger", "Error Message.", res );
        }
        if(problem === "CLIENT_ERROR"){
            res = data;
            if (res && res.message === "q is not allowed to be empty"){
                Alert(true, "danger", "Error Message", "Please input a search value.")
            }
            else {
                Alert( data , "danger", "Error Message." );
            }
        }
    }
    return res;
}

export default responseHandler;